import React from 'react';
import {HashRouter as Router, Routes, Route} from 'react-router-dom';
// import MedicineSearch from './components/search/MedicineSearch';
// import HeaderBanner from './components/header/HeaderBanner';
import './App.css';
import Footer from './components/footer/Footer';
import {AllMedicinesList} from './components/medicines/AllMedicinesList.component';
import {HomePageComponent} from './components/home/HomePageComponent';
// import {AdminPage} from './components/admin/AdminPage';
// import {AdminAddEditMedicine} from './components/admin/AdminAddEditMedicine';
// import {MedicineDetailView} from './components/search-results/MedicineDetailsComponent';

function App() {
  // const [searchResults, setSearchResults] = useState([]);

  return (
    <Router>
      <div className="App">
        {/* <HeaderBanner /> */}
        <div className="main-content-container">
          {/* <MedicineSearch /> */}
          <Routes>
            <Route path="/" element={<HomePageComponent />} />
            <Route path="/medicines" element={<AllMedicinesList />} />

            {/* <Route path="/" exact element={
              <SearchPageDefault />
            } /> */}
            {/* <Route path="/medicine/search" exact element={
              <SearchResultsView
                medicineNameInput={medicineNameInput}
                searchResults={searchResults}
              />
            } /> */}
            {/* <Route path="/medicines/:id" element={<MedicineDetailView />} />
            <Route path="/admin" element={<AdminPage />}>
              <Route path="medicines" element={<AdminAddEditMedicine />} />
            </Route> */}
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
